<div class="fwc-container sae-select_coverage-body">
  <div class="fwc-row">
    <div class="fwc-col-12 select_coverage-intro">
      <h2>{{content.sectionHead}}</h2>
      <p>{{content.sectionContent}}</p>
    </div>
  </div>
</div>
<div class="fwc-container sae-select_coverage-cards">
  <div class="fwc-row">
    <div class="fwc-col-12 fwc-card-generic flat card-container">
      <div class="fwc-container">
        @if (path !== 'waiver' && showDependents) {
          <div class="fwc-row fwc-row-bm">
            <div class="fwc-col-12">
              <h3>{{content.subHeading}}</h3>
            </div>
          </div>
          <div class="fwc-row fwc-row-bm top-xs">
            <div class="fwc-col-5 sm-8">
              <p>{{content.subContent1}}</p>
            </div>
            <div class="fwc-col-6 sm-4">
              <input type="radio" name="partner" [value]="true" id="radio_1" [checked]="partnerRadio"
                (change)="radioChange(true, 'partner')" />
              <label for="radio_1">Yes</label>
              <input type="radio" name="partner" [value]="false" id="radio_1" [checked]="!partnerRadio"
                (change)="radioChange(false, 'partner')" />
              <label for="radio_1">No</label>
            </div>
          </div>
          <div class="fwc-row fwc-row-bm top-xs">
            <div class="fwc-col-5">
              <p>{{content.subContent2}}</p>
            </div>
            <div class="fwc-col-6 ">
              <input type="radio" name="children" [value]="true" id="radio_2" [checked]="childRadio"
                (change)="radioChange(true, 'child')" />
              <label for="radio_2">Yes</label>
              <input type="radio" name="children" [value]="false" id="radio_2" checked [checked]="!childRadio"
                (change)="radioChange(false, 'child')" />
              <label for="radio_2">No</label>
            </div>
          </div>
          @if (childRadio) {
            <div class="fwc-row fwc-row-bm top-xs">
              <div class="fwc-col-5">
                <p>{{content.subContent3}}</p>
              </div>
              <div class="fwc-col-6 ">
                @for (child of childCount ; track child; let i = $index) {
                  <ng-container class="right-xxs">
                    <input type="radio" name="childCount" [value]="child" id="childCount" [checked]="child.checked"
                      (change)="getChildCount(child)" />
                    <label for="childCount" class="right-xxs">{{child.count}}</label>
                  </ng-container>
                }
                @if (showInput) {
                  <input type="number" (ngModelChange)="selectedChildCountUpdate($event)" [(ngModel)]="selectedChildCount"
                    min="1" max="10">
                }
              </div>
            </div>
          }
          <div class="fwc-row">
            <div class="fwc-col-12 fwc-divider">
            </div>
          </div>
        }

        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-12">
            <h3>{{content.terms.prompt}}</h3>
          </div>
        </div>
        <div class="fwc-row fwc-row-wrap">
          @for (card of termsData; track card; let key = $index) {
            <div class="fwc-col-4 sm-12 top-xs">
              <div class="fwc-card-generic flat card" [ngClass]="{'selected' : card.term_id == this.selectedTermId}"
                [id]="'term_card_'+ key">
                <div class="card-heading">
                  <h4>{{'Term: ' + card.term_label}}</h4>
                </div>
                <div class="card-body">
                  <div class="fwc-col-12 btm-xxs">
                    <div><strong>Coverage Dates</strong></div>
                  </div>
                  <div class="fwc-row fwc-row-bm">
                    <div class="fwc-col-6 pad-override-r fwc-flex-column">
                      <div>
                        <strong>From:</strong>
                        @if (card.payment_frequency == 'monthly' || card.payment_frequency == 'weekly' ) {
                          <fwc-tooltip
                            icon term="from"
                            message="Must be within 60 days of today's date and fall within term coverage dates."
                          class="label-tooltip"></fwc-tooltip>
                        }
                        @if (card.payment_frequency != 'monthly' && card.payment_frequency != 'weekly' ) {
                          <div
                            class="marg-bottom">
                          {{formatDate(card.coverage_start)}} </div>
                        }
                        @if (card.payment_frequency == 'monthly' || card.payment_frequency == 'weekly' ) {
                          <div>
                            <fwc-date-picker id="{{'dob-from-' + key}}" attr.input-label="{{''}}"
                              (fwc-date-picker-blur)="updateDob($event, 'from', card)"
                              attr.date-range="{{card.fromDateRange}}" attr.show-date="{{showStartDate}}"
                              attr.start-date="{{formatDate(card.fromDate ? card.fromDate : card.coverage_start)}}"
                              (fwc-date-picker-selected)="updateDob($event, 'from', card)">
                            </fwc-date-picker>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="fwc-col-6 pad-override-l fwc-flex-column">
                      <div>
                        <strong>To:</strong>
                        @if (card.payment_frequency != 'monthly' && card.payment_frequency != 'weekly' ) {
                          <div>
                          {{formatDate(card.coverage_end)}}</div>
                        }
                        @if (card.payment_frequency == 'monthly' || card.payment_frequency == 'weekly' ) {
                          <div>
                            <fwc-date-picker id="{{'dob-to-' + key}}" attr.input-label="{{''}}"
                              attr.date-range="{{card.toDateRange}}" (fwc-date-picker-blur)="updateDob($event, 'to', card)"
                              attr.show-date="{{showToDate}}"
                              attr.start-date="{{showToDate? card.toDate ? card.toDate : card.coverage_end : ''}}"
                              (fwc-date-picker-selected)="updateDob($event, 'to', card)">
                            </fwc-date-picker>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="fwc-row">
                    <div class="fwc-col-6 fwc-flex-column">
                      <div>
                        <strong>Deadline:</strong>
                        <div>{{checkDeadline(card.enroll_deadline, card.enroll_soft_deadline)}}</div>
                      </div>
                    </div>
                  </div>
                  @if (path !== 'waiver') {
                    @if (path !== 'waiver' && card.payment_frequency != 'monthly' && card.payment_frequency != 'weekly') {
                      <div class="fwc-col-12 top-xs sae-border-top"
                        >
                        <h5 class="top-xs btm-xs"><strong>Term Rates Summary</strong></h5>
                      </div>
                    }
                    @if (card.payment_frequency == 'monthly') {
                      <div class="fwc-col-12 top-xs sae-border-top">
                        <h5 class="top-xs btm-xs"><strong>Monthly Term Rates Summary</strong></h5>
                      </div>
                    }
                    @if (card.payment_frequency == 'weekly') {
                      <div class="fwc-col-12 top-xs sae-border-top">
                        <h5 class="top-xs btm-xs"><strong>Weekly Term Rates Summary</strong></h5>
                      </div>
                    }
                    @if (!card.hideStudentRate) {
                      <div class="fwc-row">
                        <div class="fwc-col-6 btm-xxs ">
                          <div [ngClass]="'gray-font'">Student</div>
                        </div>
                        <div class="fwc-col-6 btm-xxs align_end">
                          @if (card.student_total===null) {
                            <div [ngClass]="'gray-font'">{{0 | currency}}
                            </div>
                          } @else {
                            <div [ngClass]="'gray-font'">{{card.student_total | currency}}</div>
                          }
                        </div>
                      </div>
                    }
                    @if ((((card.dependents_oneplus_total !== null && card.dependents_oneplus_total !== undefined) && totalDependentCount >= 1) ||
                      ((card.dependents_twoplus_total !== null && card.dependents_twoplus_total !== undefined) && totalDependentCount >= 2) ||
                      ((card.dependents_threeplus_total !== null && card.dependents_threeplus_total !== undefined) && totalDependentCount >= 3))) {
                      @if ((card.dependents_oneplus_total !== null && card.dependents_oneplus_total !== undefined) && totalDependentCount >= 1) {
                        <div class="fwc-row"
                          >
                          <div class="fwc-col-6 btm-xxs ">
                            <div [ngClass]="'gray-font'">Dependents [1 or More]
                            </div>
                          </div>
                          <div class="fwc-col-6 btm-xxs align_end">
                            <div [ngClass]="'gray-font'">{{card.dependents_oneplus_total | currency}}</div>
                          </div>
                        </div>
                      }
                      @if ((card.dependents_twoplus_total !== null && card.dependents_twoplus_total !== undefined) && totalDependentCount >= 1) {
                        <div class="fwc-row"
                          >
                          <div class="fwc-col-6 btm-xxs ">
                            <div [ngClass]="'gray-font'">Dependents [2 or More]
                            </div>
                          </div>
                          <div class="fwc-col-6 btm-xxs align_end">
                            <div [ngClass]="'gray-font'">{{card.dependents_twoplus_total | currency}}</div>
                          </div>
                        </div>
                      }
                      @if ((card.dependents_threeplus_total !== null && card.dependents_threeplus_total !== undefined) && totalDependentCount >= 1) {
                        <div class="fwc-row"
                          >
                          <div class="fwc-col-6 btm-xxs ">
                            <div [ngClass]="'gray-font'">Dependents [3 or More]
                            </div>
                          </div>
                          <div class="fwc-col-6 btm-xxs align_end">
                            <div [ngClass]="'gray-font'">{{card.dependents_threeplus_total | currency}}</div>
                          </div>
                        </div>
                      }
                    } @else {
                      @if (partnerRadio && (card.spouse_total || card.spouse_total === 0)) {
                        <div class="fwc-row">
                          <div class="fwc-col-6 btm-xxs ">
                            <div [ngClass]="'gray-font'">Spouse/Domestic Partner
                            </div>
                          </div>
                          <div class="fwc-col-6 btm-xxs align_end">
                            <div [ngClass]="'gray-font'">{{card.spouse_total | currency}}</div>
                          </div>
                        </div>
                      }
                      @if (childRadio && selectedChildCount > 0 && selectedChildCount < 2 && (card.child_total || card.child_total === 0)) {
                        <div class="fwc-row"
                          >
                          <div class="fwc-col-6 btm-xxs ">
                            <div [ngClass]="'gray-font'">Child(ren)
                            </div>
                          </div>
                          <div class="fwc-col-6 btm-xxs align_end">
                            <div [ngClass]="'gray-font'">{{card.child_total | currency}}</div>
                          </div>
                        </div>
                      }
                      @if (childRadio && selectedChildCount >= 2 && (card.child_bulk_total || card.child_bulk_total === 0)) {
                        <div class="fwc-row"
                          >
                          <div class="fwc-col-6 btm-xxs ">
                            <div [ngClass]="'gray-font'">Children (2 or more)
                            </div>
                          </div>
                          <div class="fwc-col-6 btm-xxs align_end">
                            <div [ngClass]="'gray-font'">{{card.child_bulk_total | currency}}</div>
                          </div>
                        </div>
                      }
                    }
                    <hr>
                      <div class="fwc-row">
                        <div class="fwc-col-6 btm-xxs ">
                          <div [ngClass]="'total'">Total
                          </div>
                        </div>
                        @if ((card.payment_frequency !== 'once' && !showToDate)) {
                          <div class="fwc-col-6 btm-xxs align_end" >
                            <div class="total">0.00</div>
                          </div>
                        } @else {
                          @if (!partnerRadio && !childRadio && (card.payment_frequency === 'once' || showToDate)) {
                            <div class="fwc-col-6 btm-xxs align_end">
                              <div [ngClass]="'total'">{{card.monthly_student_total | currency }}</div>
                            </div>
                          }
                          @if ((((card.dependents_oneplus_total && card.dependents_oneplus_total !== 0) && totalDependentCount >= 1) ||
                            ((card.dependents_twoplus_total && card.dependents_twoplus_total !== 0) && totalDependentCount >= 2) ||
                            ((card.dependents_threeplus_total && card.dependents_threeplus_total !== 0) && totalDependentCount >= 3))) {
                            @if ((card.dependents_oneplus_total && card.dependents_oneplus_total !== 0) && totalDependentCount >= 1) {
                              <div class="fwc-col-6 btm-xxs align_end"
                                >
                                <div [ngClass]="'total'">{{card.monthly_student_total + card.monthly_dependents_oneplus |
                                currency}}</div>
                              </div>
                            }
                            @if ((card.dependents_twoplus_total && card.dependents_twoplus_total !== 0) && totalDependentCount >= 1) {
                              <div class="fwc-col-6 btm-xxs align_end"
                                >
                                <div [ngClass]="'total'">{{card.monthly_student_total + card.monthly_dependents_twoplus |
                                currency}}</div>
                              </div>
                            }
                            @if ((card.dependents_threeplus_total && card.dependents_threeplus_total !== 0) && totalDependentCount >= 1) {
                              <div class="fwc-col-6 btm-xxs align_end"
                                >
                                <div [ngClass]="'total'">{{card.monthly_student_total + card.monthly_dependents_threeplus |
                                currency}}</div>
                              </div>
                            }
                          } @else {
                            @if (partnerRadio && !childRadio) {
                              <div class="fwc-col-6 btm-xxs align_end">
                                <div [ngClass]="'total'">{{card.monthly_student_total + card.monthly_spouse_total | currency}}
                                </div>
                              </div>
                            }
                            @if (!partnerRadio && childRadio && selectedChildCount < 2) {
                              <div class="fwc-col-6 btm-xxs align_end"
                                >
                                <div [ngClass]="'total'">{{card.monthly_student_total +
                                  (card.monthly_child_total*selectedChildCount) | currency}}
                                </div>
                              </div>
                            }
                            @if (!partnerRadio && childRadio && selectedChildCount >= 2) {
                              <div class="fwc-col-6 btm-xxs align_end"
                                >
                                <div [ngClass]="'total'">{{card.monthly_student_total + card.monthly_child_bulk_total |
                                  currency}}
                                </div>
                              </div>
                            }
                            @if (partnerRadio && childRadio && selectedChildCount >= 2) {
                              <div class="fwc-col-6 btm-xxs align_end"
                                >
                                <div [ngClass]="'total'">{{card.monthly_student_total + card.monthly_spouse_total +
                                  card.monthly_child_bulk_total | currency
                                }}</div>
                              </div>
                            }
                            @if (partnerRadio && childRadio && selectedChildCount < 2) {
                              <div class="fwc-col-6 btm-xxs align_end"
                                >
                                <div [ngClass]="'total'">{{card.monthly_student_total + card.monthly_spouse_total +
                                  (card.monthly_child_total*selectedChildCount) | currency}}
                                </div>
                              </div>
                            }
                          }
                        }
                      </div>
                    }
                    <!-- <div class="fwc-row " *ngFor="let rate of card.Rates">
                    <div class="fwc-col-6 btm-xxs ">
                      <div [ngClass]="rate.for == 'Total' ? 'total' : 'gray-font' ">{{rate.for}}</div>
                    </div>
                    <div class="fwc-col-6 btm-xxs align_end">
                      <div [ngClass]="rate.for == 'Total' ? 'total' : 'gray-font' ">{{rate.rate}}</div>
                    </div>
                  </div> -->
                </div>
                <div class="card-action fwc-flex j-center">
                  <div>
                    <a href="javascript:void(0)" (click)="selectTerm(card.term_id, card)">
                      @if (card.term_id == this.selectedTermId) {
                        <span>Selected term</span>
                      }
                      @if (card.term_id != this.selectedTermId) {
                        <span>Select this term</span>
                      }
                    </a>
                    <span class="fwc-icon fwc-icon-circle-check left-xxs"></span>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="fwc-row">
          <div class="fwc-col-12 fwc-divider">
          </div>
        </div>
        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-12">
            <h3>{{content.terms.disclosureHead}}</h3>
          </div>
        </div>
        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-12">
            <div>{{content.terms.disclosureBody}}</div>
          </div>
        </div>
        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-12 disclosure-container">
            <div class="fwc-checkbox">
              <input type="checkbox" name="disclosureCheckbox" id="disclosureCheckbox" value="true"
                [(ngModel)]="newEnrollmentAgreement" (keydown.enter)="newEnrollmentAgreement = !newEnrollmentAgreement" />
              <label for="disclosureCheckbox"><strong>{{content.terms.disclosureAgree}}</strong></label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>